import { render } from "./TreeSelectPanel.vue?vue&type=template&id=5fba3283"
import script from "./TreeSelectPanel.vue?vue&type=script&lang=js"
export * from "./TreeSelectPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__